import CheckIcon from "icons/CheckIcon";
import EditIcon from "icons/EditIcon";
import OpenEyeIcon from "icons/OpenEyeIcon";
import StopIcon from "icons/StopIcon";
import {
	ActionCell,
	ActionIconButton,
	CampusCell,
	CampusTag,
	CampusTagList,
	NameCell,
	StatusBadge,
	TypeCell,
	ValidityCell,
} from "../../styles";
import {
	getCampusNamesByIds,
	getSignatureTypeLabel,
	getValidityText,
} from "../../utils/helpers";

const TableListItem = ({
	item,
	allCampus,
	openForm,
	openFile,
	openToggleDialog,
}) => {
	const campusNames = getCampusNamesByIds(item.campusIds, allCampus);
	const visibleCampusNames = campusNames.slice(0, 2);
	const hiddenCampusCount = Math.max(campusNames.length - visibleCampusNames.length, 0);
	return (
		<tr>
			<td>
				<TypeCell>
					<strong title={getSignatureTypeLabel(item.signatureTypeCode)}>
						{getSignatureTypeLabel(item.signatureTypeCode)}
					</strong>
				</TypeCell>
			</td>
			<td>
				<NameCell>
					<strong title={item.displayName}>{item.displayName}</strong>
					{item.utpCode ? <span title={item.utpCode}>{item.utpCode}</span> : null}
				</NameCell>
			</td>
			<td>
				<CampusCell>
					<CampusTagList>
						{visibleCampusNames.map(name => (
							<CampusTag key={name} title={name}>{name}</CampusTag>
						))}
						{hiddenCampusCount > 0 ? (
							<CampusTag>{`+${hiddenCampusCount}`}</CampusTag>
						) : null}
					</CampusTagList>
				</CampusCell>
			</td>
			<td>
				<ValidityCell>
					<strong>{item.isIndefiniteValidity ? "Indeterminada" : "Programada"}</strong>
					<span title={getValidityText(item)}>{getValidityText(item)}</span>
				</ValidityCell>
			</td>
			<td>
				<StatusBadge active={item.isActive}>
					{item.isActive ? "Activo" : "Inactivo"}
				</StatusBadge>
			</td>
			<td>
				<ActionCell>
					{item.signatureFile?.path ? (
						<ActionIconButton
							type="button"
							title="Ver firma"
							aria-label="Ver firma"
							onClick={() => openFile(item)}
						>
							<OpenEyeIcon />
						</ActionIconButton>
					) : (
						<span />
					)}
				</ActionCell>
			</td>
			<td>
				<ActionCell>
					<ActionIconButton
						type="button"
						title="Editar firma"
						aria-label="Editar firma"
						onClick={() => openForm(item)}
					>
						<EditIcon />
					</ActionIconButton>
				</ActionCell>
			</td>
			<td>
				<ActionCell>
					<ActionIconButton
						type="button"
						tone={item.isActive ? "warning" : "success"}
						title={item.isActive ? "Desactivar firma" : "Activar firma"}
						aria-label={item.isActive ? "Desactivar firma" : "Activar firma"}
						onClick={() => openToggleDialog(item)}
					>
						{item.isActive ? <StopIcon /> : <CheckIcon color="currentColor" />}
					</ActionIconButton>
				</ActionCell>
			</td>
		</tr>
	);
};

export default TableListItem;
